export default "__VITE_ASSET__CSpQzaNl__"